import { AxiosInstance } from 'axios';
import { InvitePoints, CreateInvite, CreatePassword } from './types';
import {
  mapPerson,
  mapUser,
  parseInvited,
  PromiseParsedInvited,
  PromiseDataParsedPerson,
} from './utils';

// const getCurrentInviteData = (api: AxiosInstance) => ({
//   getCurrentInvite: async (): Promise<PromiseDataParsedPerson> => {
//     const { data } = await api.get(InvitePoints.GET_CURRENT_INVITES);
//     return { ...data, data: mapPerson(data.data) };
//   },
// });

// const getCurrentUsersData = (api: AxiosInstance) => ({
//   getCurrentUsers: async (): Promise<PromiseDataParsedPerson> => {
//     const { data } = await api.get(InvitePoints.GET_CURRENT_USERS);
//     return { ...data, data: mapUser(data.data) };
//   },
// });

const getSearchInviteData = (api: AxiosInstance) => ({
  getSearchInvite: async (code: string): Promise<PromiseParsedInvited> => {
    const { data } = await api.get(InvitePoints.GET_IVITE_SEARCH, {
      params: { code },
    });
    return { ...data, data: parseInvited(data.data) };
  },
});

const postCreateInviteData = (api: AxiosInstance) => ({
  postCreateInvite: async (payload: CreateInvite): Promise<any> => {
    const result = await api.post(InvitePoints.POST_IVITE_CREATE, {
      data: payload,
    });
    return result;
  },
});

const postRegisterInviteData = (api: AxiosInstance) => ({
  postRegisterInvite: async (payload: CreatePassword): Promise<any> => {
    const result = await api.post(InvitePoints.POST_IVITE_REGISTER, {
      data: payload,
    });
    return result;
  },
});

const inviteService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getSearchInviteData(api),
    ...postCreateInviteData(api),
    ...postRegisterInviteData(api),
  };
};

export default inviteService;



// WEBPACK FOOTER //
// ./src/services/invite/inviteService.ts